import { Subscription } from 'rxjs';
import { Directive, OnChanges, SimpleChanges } from '@angular/core';
import { AppConfigService } from '../../../core/services/app-config.service';
import { AbstractComponent } from './abstract.component';

@Directive()
export abstract class AbstractHistoryInput extends AbstractComponent implements OnChanges {
  private einstellungHistorisiertSub: Subscription;

  constructor(protected appConfigService: AppConfigService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isLoadRelevantInputChange(changes)) {
      return;
    }
    if (!this.einstellungHistorisiertSub) {
      this.einstellungHistorisiertSub = this.appConfigService.historisiertEvent$.subscribe(() => {
        this.loadData();
      });
      this.addSub(this.einstellungHistorisiertSub);
    }
    this.loadData();
  }

  protected abstract isLoadRelevantInputChange(changes: SimpleChanges): boolean;

  protected abstract loadData();
}
